import { gql } from '@apollo/client';

export interface RemoveAssignmentMutationVariables {
  courseId: string;
  assignmentId: string;
}

export interface RemoveAssignmentMutationResult {
  assignment: {
    id: string;
  };
}

export const removeAssignmentMutation = gql`
  mutation RemoveAssignmentMutation($courseId: String!, $assignmentId: String!) {
    assignment(courseId: $courseId, assignmentId: $assignmentId, input: {})
      @rest(type: "Assignment", path: "courses/{args.courseId}/assignments/{args.assignmentId}", method: "DELETE") {
      id: _id
    }
  }
`;
